export const handleLegendMouseOver = (d, chart) => {
  chart.selectAll(`.value-${d}`).style('opacity', 0.7);
};

export const handleLegendMouseOut = (d, chart) => {
  chart.selectAll(`.value-${d}`).style('opacity', null);
};
